module.exports = __webpack_public_path__ + "img/remove-minus-icon.0b809363.svg";